var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.869019,
    y: 0.59668,
    width: 34.7463,
    height: 34.7463,
    rx: 2.89552,
    stroke: "#FF6900",
    strokeWidth: 0.579104
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5611 17.315C15.5938 17.2814 15.7174 17.1378 15.8325 17.0197C16.5072 16.2767 18.2674 15.0606 19.1886 14.6894C19.3285 14.6297 19.6823 14.5035 19.8712 14.4954C20.0523 14.4954 20.225 14.5371 20.3897 14.6216C20.5951 14.7397 20.7598 14.9256 20.8501 15.1451C20.9082 15.2974 20.9984 15.7532 20.9984 15.7613C21.0887 16.2599 21.1383 17.0701 21.1383 17.9654C21.1383 18.8184 21.0887 19.5955 21.0148 20.1017C21.0063 20.1098 20.9161 20.6761 20.8173 20.8701C20.6362 21.2246 20.2825 21.4446 19.904 21.4446H19.8712C19.6247 21.4359 19.1063 21.2159 19.1063 21.2078C18.2346 20.836 16.5151 19.6795 15.824 18.911C15.824 18.911 15.6294 18.7136 15.5447 18.5902C15.4127 18.413 15.3473 18.1935 15.3473 17.974C15.3473 17.7291 15.4212 17.5009 15.5611 17.315",
    fill: "#FF6900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left_icon.4d09e85fb88006141471ed721614ff89.svg";
export { ForwardRef as ReactComponent };